const getEndPoint = (endPoint: string = '') => {
  return process.env.REACT_APP_BASE_URL + endPoint;
};

export const apiPath = {
  SITE_ONTOLOGY_LEVELS_URL: getEndPoint(process.env.REACT_APP_API_SITE_ONTOLOGY_LEVELS),
  SITE_ONTOLOGY_MASTER_URL: getEndPoint(process.env.REACT_APP_API_SITE_ONTOLOGY_MASTER),
  SITE_FACTORY_MANAGEMENT_URL: getEndPoint(process.env.REACT_APP_API_SITE_FACTORY),

  THINGS_COMPONENTS_BASE_URL: getEndPoint(process.env.REACT_APP_API_THINGS_COMPONENTS),
  THINGS_SERVICES_BASE_URL: getEndPoint(process.env.REACT_APP_API_THINGS_SERVICES),
  THINGS_MACHINES_BASE_URL: getEndPoint(process.env.REACT_APP_API_THINGS_MACHINES),
  THINGS_PARTS_BASE_URL: getEndPoint(process.env.REACT_APP_API_THINGS_PARTS),
  THINGS_GATEWAYS_BASE_URL: getEndPoint(process.env.REACT_APP_API_THINGS_GATEWAYS),
  THINGS_ASSETS_BASE_URL: getEndPoint(process.env.REACT_APP_API_THINGS_ASSETS),
  THINGS_NOTIFICATIONS_URL: getEndPoint(process.env.REACT_APP_API_THINGS_NOTIFICATIONS),
  THINGS_EMQX_URL: getEndPoint(process.env.REACT_APP_API_THINGS_EMQX),
  THINGS_UI_URL: getEndPoint(process.env.REACT_APP_API_THINGS_UI),
  THINGS_BACKEND_URL: getEndPoint(process.env.REACT_APP_API_THINGS_BACKEND),
  THINGS_INFLUX_URL: getEndPoint(process.env.REACT_APP_API_THINGS_INFLUX),
  THINGS_EMQX_INFLUX_URL: getEndPoint(process.env.REACT_APP_API_THINGS_EMQX_INFLUX),

  BUILD_USE_CASE_BASE_URL: getEndPoint(process.env.REACT_APP_API_BUILD_USE_CASE),
  USER_SERVICE_BASE_URL: getEndPoint(process.env.REACT_APP_API_USER_SERVICE),
  BASE_URL_API: process.env.REACT_APP_BASE_URL,
  SETTING_SERVICE_BASE_URL : getEndPoint(process.env.REACT_APP_API_TENANT_SERVICE),
  DIGITAL_TWIN_BASE_URL:getEndPoint(process.env.REACT_APP_API_DIGITAL_TWIN),
  SECRET_MANAGER_BASE_URL :getEndPoint(process.env.REACT_APP_SECRETS_API),

  MAINTENANCE: getEndPoint(process.env.REACT_APP_API_MAINTENANCE),
  USECASE_MGMNT: getEndPoint(process.env.REACT_APP_API_USECASE_MGMNT),
};
